<template>
    <div class="signUpForm">
        <div class="pt-4 mx-3">
            <div class="d-flex justify-content-center align-items-center">
                <img border="0" :src="imgPath" width="120" height="120" alt="">
            </div>
            <h2 class="text-center py-3 bg-single comment-color">会員新規登録（仮登録）</h2>
            <div class="row no-gutters justify-content-center">
                <div class="signContents">
                    <p class="mb-4 comment-color">
                        入力したメールアドレスにメールを送信しました。
                    </p>
                    <p class="mb-4 comment-color">
                        メールに記載されているURLをクリックして本登録を完了してください。<br />
                        メールが届かない場合は下記までお問い合わせください。<br />
                        {{ this.info_mail }}
                    </p>
                </div>
            </div>
            <div class="row no-gutters justify-content-center pb-4" v-if="btnUse">
                <button
                    type="button"
                    class="confirmbutton col-sm-5"
                    @click="toLoginPage()"
                >
                    {{ btnNmae }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            info_mail: process.env.MIX_SUPPORT_MAILADDRESS,
            btnUse: false,
            btnNmae: '',
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png"
        };
    },
    created() {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function() {
            if (process.env.MIX_APP_URL) {
                this.btnUse = false;
                this.btnNmae = 'アプリを起動';
            } else {
                this.btnUse = true;
                this.btnNmae = 'ログインページに戻る';
            }
        },
        toLoginPage: function() {
            if (process.env.MIX_APP_URL) {
                window.location.href = process.env.MIX_APP_URL;
            } else {
                if (!this.$route.query.gc || !this.$route.query.ud) {
                    this.$router.push("/");
                } else {
                    this.$router.push("/?gc=" + this.$route.query.gc + "&ud=" + this.$route.query.ud);
                }
            }
        }
    }
};
</script>

<style scoped>
    @media screen and (min-width: 576px) {
        .signContents {
            width: 530px;
        }
    }
    .signUpForm {
        height: 100vh;
    }
</style>
